import GetPropertyInstanceMixin from "./GetPropertyInstanceMixin";
import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
import {PROPERTY_SEARCH_DISABLED_OPTION, RELOAD_FAVORITES_MAP} from './PropertySearchMixin.js';
import {PROPERTY_SEARCH_ACTIONS} from "../../helpers/variables";
import {TABS} from "../components/GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeaderTab/PropertySearchHeaderTab";

export const PROPERTY_DETAILS_FAVORITE_ACTION = 'PropertyDetails:favorite-action';
export const PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION = 'PropertyMapCard:favorite-action';
export const PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION = 'PropertyListingCard:favorite-action';
export const FAV_CLICK_LOADING = 'FAV_CLICK_LOADING';

export default {
    name: 'FavoriteButtonMixin',
    mixins: [GetPropertyInstanceMixin, ShowNotificationMixin],
    props: {
        favoriteOptionEnabled: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            favorite: null,
            favoriteIsLoading: false,
        };
    },

    computed: {
        /**
         * Check if the property is marked as favorite
         *
         * @returns {boolean}
         */
        isFavorite() {
            return this.favorite !== null ? this.favorite : this.propertyAppResource && this.propertyAppResource.isFavorite;
        }
    },

    methods: {
        async handleFavClick() {
            if (!this.favoriteOptionEnabled) {
                this.$bus.$emit(
                    PROPERTY_SEARCH_DISABLED_OPTION,
                    PROPERTY_SEARCH_ACTIONS.FAVORITE,
                    {propertyUuid: this.propertyAppResource.uuid}
                );
                return;
            }
            this.favoriteIsLoading = true;
            try {
                const propertyInstance = await this.getPropertyInstance();
                if ((propertyInstance || {}).propertyUuid) {
                    propertyInstance.isFavorite = !propertyInstance.isFavorite;
                    propertyInstance._dirty['isFavorite'] = true;
                    await propertyInstance.save();
                    this.favorite = propertyInstance.isFavorite;
                    this.$bus.$emit(
                        PROPERTY_DETAILS_FAVORITE_ACTION, this.favorite, propertyInstance.propertyUuid
                    );
                    this.$bus.$emit(
                        PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION, this.favorite, propertyInstance.propertyUuid
                    );
                    this.$bus.$emit(
                        PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION, this.favorite, propertyInstance.propertyUuid)
                    ;
                } else {
                    throw 'No property instance found!';
                }
            } catch (e) {
                this.showNotification({
                    message: 'Something went wrong. Please try again later',
                    type: 'error'
                });
                console.error(e);
                this.favoriteIsLoading = false;
            } finally {
                this.favoriteIsLoading = false;
            }

            if (this.$route.query.tab === TABS.FAVORITE && !this.favorite) {
                this.$bus.$emit(RELOAD_FAVORITES_MAP, 1);
            }

            return this.favorite;
        },

        async favoriteProperty() {
            const propertyInstance = await this.getPropertyInstance(true);
            if (!propertyInstance.isFavorite) {
                propertyInstance.isFavorite = true;
                propertyInstance._dirty['isFavorite'] = true;
                await propertyInstance.save();
                this.favorite = propertyInstance.isFavorite;
                this.$bus.$emit(PROPERTY_DETAILS_FAVORITE_ACTION, this.favorite, propertyInstance.propertyUuid);
                this.$bus.$emit(PROPERTY_MAP_CARD_FAVORITE_BUTTON_FAVORITE_ACTION, this.favorite, propertyInstance.propertyUuid);
                this.$bus.$emit(
                    PROPERTY_LISTING_CARD_FAVORITE_BUTTON_FAVORITE_ACTION,
                    this.favorite, propertyInstance.propertyUuid
                );
            }

            return propertyInstance;
        }
    }
};
